
import React from 'react';
import { Brand } from '../types';

interface BrandsMarqueeProps {
  brands: Brand[];
}

const BrandsMarquee: React.FC<BrandsMarqueeProps> = ({ brands }) => {
  if (brands.length === 0) return null;

  // Duplicate items for marquee effect
  const marqueeItems = [...brands, ...brands, ...brands, ...brands];

  return (
    <section id="brands-marquee" className="py-20 bg-white dark:bg-slate-950 border-t border-slate-100 dark:border-slate-900 overflow-hidden transition-colors">
      <div className="max-w-7xl mx-auto px-4 mb-12 text-center">
        <h2 className="text-blue-800 dark:text-blue-400 font-black text-[9px] uppercase tracking-[0.4em] mb-2">Our Clients</h2>
        <h3 className="text-3xl md:text-4xl font-black text-slate-900 dark:text-white uppercase tracking-tighter leading-none">
          Trusted by <span className="text-blue-600">Industry Leaders</span>
        </h3>
      </div>

      <div className="relative">
        <div className="flex overflow-hidden relative">
          <div className="animate-marquee flex items-center">
            {marqueeItems.map((brand, idx) => (
              <div 
                key={`${brand.id}-${idx}`} 
                className="mx-6 md:mx-10 shrink-0 h-20 md:h-28 w-48 md:w-72 flex items-center justify-center bg-white p-4 rounded-xl hover:scale-110 transition-all duration-500"
              >
                <img 
                  src={brand.imageUrl} 
                  alt={brand.name} 
                  className="max-h-full max-w-full object-contain"
                  referrerPolicy="no-referrer"
                />
              </div>
            ))}
          </div>
        </div>
        
        {/* Gradient overlays for smooth fade */}
        <div className="absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-white dark:from-slate-950 to-transparent pointer-events-none z-10"></div>
        <div className="absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-white dark:from-slate-950 to-transparent pointer-events-none z-10"></div>
      </div>
    </section>
  );
};

export default BrandsMarquee;
